export default {
    bancos: [],
    bancosFiltros: [],
    bancosExport: [],
    bancosFiltersExport: [],
    movimientosBancos: [],
    movimientosBancosFiltros: [],
    movimientosBancosExport: [],
    movimientosBancosFiltersExport: [],
    statusApiBanco: {
        message: "",
        success: ""
    },
    totalMovimientosBanco: 0,
    totalBancos: 0
}